import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { RequestHistoryService } from '../services/requests/history/request-history.service';

@Injectable({
  providedIn: 'root'
})
export class ProcessamentoGuard implements CanActivate {

  constructor(
    private router: Router,
    private requestHistoryService: RequestHistoryService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.requestHistoryService.listarProcessamentos().pipe(
      map(data => {
        if (data == null) {
          return true
        }

        if(data.importacaoEmAndamento){
            const queryParams = {
              ...(data.importacaoEmAndamento && { importacao: 'S' })
            };

            return this.router.createUrlTree(['home/pedidos/acompanhamento/reprocessamento'],{ queryParams});

          }


        if (data.listaPedidosEmProcessamento.length > 0){
          return this.router.createUrlTree(['home/pedidos/acompanhamento/reprocessamento']);
        }
        return true;
      }),
      catchError(() => {
        return of(true);
      })
    );
  }
}
